// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LoadingScreen_spinner__1GQr_"};